import { defineStore } from "pinia";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { allBranches } from "@/repository/api";

export const useBranchesStore = defineStore(
    "branches",
    () => {
        const branches = ref([]);
        const selectedBranchId = ref(null);
        const selectedBranchData = ref([]);
        const router = useRouter();

        watch(
            () => router.currentRoute.value.params?.branch,
            (newBranch) => {
                if (newBranch) {
                    setSelectedBranch(newBranch);
                }
            },
        );

        const setBranches = (listBranches) => {
            branches.value = listBranches;
        };

        const setSelectedBranch = (branch) => {
            selectedBranchId.value = branch;
            selectedBranchData.value = branches.value.find(
                (item) => Number(item.id) === Number(branch),
            );
            router.push({
                params: { branch: branch },
            });
        };

        const preselectDefaultBranch = () => {
            if (branches.value.length > 0) {
                if (router.currentRoute.value.params?.branch) {
                    const routeBranch =
                        router.currentRoute.value.params?.branch;
                    const branchExists = branches.value.find(
                        (item) => Number(item.id) === Number(routeBranch),
                    );
                    if (branchExists) {
                        setSelectedBranch(routeBranch);
                        return;
                    }
                } else {
                    if (selectedBranchId.value) {
                        return;
                    } else {
                        setSelectedBranch(branches.value[0].id);
                    }
                }
            }
        };

        const loadBranches = async () => {
            branches.value = await allBranches();
            preselectDefaultBranch();
        };

        return {
            branches,
            selectedBranchId,
            selectedBranchData,
            setBranches,
            setSelectedBranch,
            loadBranches,
            preselectDefaultBranch,
        };
    },
    {
        persist: true,
    },
);
